<input #inputCheck
       class="checkbox-checked"
       type="checkbox"
       [checked]="inputValue"
       [disabled]="inputIsDisable">{{label}}

<div class="select-edit-btn-area">
  <i *ngIf="isAdmin"
     class="fa fa-edit transition text-tooltip"
     aria-hidden="true"
     title-popup="Edit"
     (click)="inputOnClick(inputCheck)"
     [hidden]="inputIsHidden"></i>

  <button class="transition text-tooltip tooltip-edit"
          [hidden]="!inputIsHidden"
          (click)="inputOnSave(inputCheck)"
          [disabled]="hasError"
          title-popup="Save">
    <i class="fa fa-check"
       [ngClass]="{'disabled':hasError}"
       aria-hidden="true"></i>
  </button>

  <button class="transition text-tooltip tooltip-edit"
          title-popup="Cancel"
          [hidden]="!inputIsHidden"
          (click)="inputOnCancel(inputCheck)">
    <i class="fa fa-times"
       aria-hidden="true"></i>
  </button>
</div>
<div class="alert alert-danger alert-validate error-validate"
     *ngIf="hasError">{{errorMessage}}
</div>
